// extracted by mini-css-extract-plugin
export default {"container":"cdtygK","image":"dOiNk1","content":"eiVUYR","title":"vTDj28","description":"g1TrH7"};